import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import { Animated, Platform } from 'react-native';
import { State, BaseButton } from '../GestureHandler';
import PropTypes from 'prop-types';
/**
 * Each touchable is a states' machine which preforms transitions.
 * On very beginning (and on the very end or recognition) touchable is
 * UNDETERMINED. Then it moves to BEGAN. If touchable recognizes that finger
 * travel outside it transits to special MOVED_OUTSIDE state. Gesture recognition
 * finishes in UNDETERMINED state.
 */

export var TOUCHABLE_STATE = {
  UNDETERMINED: 0,
  BEGAN: 1,
  MOVED_OUTSIDE: 2
};
var PublicPropTypes = {
  // Decided to drop not used fields from RN's implementation.
  // e.g. onBlur and onFocus as well as deprecated props.
  accessible: PropTypes.bool,
  accessibilityLabel: PropTypes.node,
  accessibilityHint: PropTypes.string,
  hitSlop: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    bottom: PropTypes.number,
    right: PropTypes.number
  }),
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  onPressIn: PropTypes.func,
  onPressOut: PropTypes.func,
  onLayout: PropTypes.func,
  onLongPress: PropTypes.func,
  nativeID: PropTypes.string,
  testID: PropTypes.string,
  delayPressIn: PropTypes.number,
  delayPressOut: PropTypes.number,
  delayLongPress: PropTypes.number
};
var InternalPropTypes = {
  extraButtonProps: PropTypes.object,
  onStateChange: PropTypes.func
};
/**
 * GenericTouchable is not intented to be used as it.
 * Should be treated as a source for the rest of touchables
 */

var GenericTouchable =
/*#__PURE__*/
function (_Component) {
  _inherits(GenericTouchable, _Component);

  function GenericTouchable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GenericTouchable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GenericTouchable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "longPressDetected", false);

    _defineProperty(_assertThisInitialized(_this), "pointerInside", true);

    _defineProperty(_assertThisInitialized(_this), "STATE", TOUCHABLE_STATE.UNDETERMINED);

    _defineProperty(_assertThisInitialized(_this), "handlePressIn", function () {
      if (_this.props.delayPressIn) {
        _this.pressInTimeout = setTimeout(function () {
          _this.moveToState(TOUCHABLE_STATE.BEGAN);

          _this.pressInTimeout = null;
        }, _this.props.delayPressIn);
      } else {
        _this.moveToState(TOUCHABLE_STATE.BEGAN);
      }

      if (_this.props.onLongPress) {
        var time = (_this.props.delayPressIn || 0) + (_this.props.delayLongPress || 0);
        _this.longPressTimeout = setTimeout(_this.onLongPressDetected, time);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMoveOutside", function () {
      if (_this.props.delayPressOut) {
        _this.pressOutTimeout = _this.pressOutTimeout || setTimeout(function () {
          _this.moveToState(TOUCHABLE_STATE.MOVED_OUTSIDE);

          _this.pressOutTimeout = null;
        }, _this.props.delayPressOut);
      } else {
        _this.moveToState(TOUCHABLE_STATE.MOVED_OUTSIDE);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleGoToUndetermined", function () {
      clearTimeout(_this.pressOutTimeout);

      if (_this.props.delayPressOut) {
        _this.pressOutTimeout = setTimeout(function () {
          if (_this.STATE === TOUCHABLE_STATE.UNDETERMINED) {
            _this.moveToState(TOUCHABLE_STATE.BEGAN);
          }

          _this.moveToState(TOUCHABLE_STATE.UNDETERMINED);

          _this.pressOutTimeout = null;
        }, _this.props.delayPressOut);
      } else {
        if (_this.STATE === TOUCHABLE_STATE.UNDETERMINED) {
          _this.moveToState(TOUCHABLE_STATE.BEGAN);
        }

        _this.moveToState(TOUCHABLE_STATE.UNDETERMINED);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "moveToState", function (newState) {
      if (newState === _this.STATE) {
        // Ignore dummy transitions
        return;
      }

      if (newState === TOUCHABLE_STATE.BEGAN) {
        // First touch and moving inside
        _this.props.onPressIn && _this.props.onPressIn();
      } else if (newState === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        // Moving outside
        _this.props.onPressOut && _this.props.onPressOut();
      } else if (newState === TOUCHABLE_STATE.UNDETERMINED) {
        // Need to reset each time on transition to UNDETERMINED
        _this.reset();

        if (_this.STATE === TOUCHABLE_STATE.BEGAN) {
          // ... and if it happens inside button.
          _this.props.onPressOut && _this.props.onPressOut();
        }
      } // Finally call lister (used by subclasses)


      _this.props.onStateChange && _this.props.onStateChange(_this.STATE, newState); // ... and make transition.

      _this.STATE = newState;
    });

    _defineProperty(_assertThisInitialized(_this), "onGestureEvent", function (_ref) {
      var pointerInside = _ref.nativeEvent.pointerInside;

      if (_this.pointerInside !== pointerInside) {
        if (pointerInside) {
          _this.onMoveIn();
        } else {
          _this.onMoveOut();
        }
      }

      _this.pointerInside = pointerInside;
    });

    _defineProperty(_assertThisInitialized(_this), "onHandlerStateChange", function (_ref2) {
      var nativeEvent = _ref2.nativeEvent;
      var state = nativeEvent.state;

      if (state === State.CANCELLED || state === State.FAILED) {
        // Need to handle case with external cancellation (e.g. by ScrollView)
        _this.moveToState(TOUCHABLE_STATE.UNDETERMINED);
      } else if ( // This platform check is an implication of slightly different behavior of handlers on different platform.
      // And Android "Active" state is achieving on first move of a finger, not on press in.
      // On iOS event on "Began" is not delivered.
      state === (Platform.OS === 'ios' ? State.ACTIVE : State.BEGAN) && _this.STATE === TOUCHABLE_STATE.UNDETERMINED) {
        // Moving inside requires
        _this.handlePressIn();
      } else if (state === State.END) {
        var shouldCallOnPress = !_this.longPressDetected && _this.STATE !== TOUCHABLE_STATE.MOVED_OUTSIDE && _this.pressOutTimeout === null;

        _this.handleGoToUndetermined();

        if (shouldCallOnPress) {
          // Calls only inside component whether no long press was called previously
          _this.props.onPress && _this.props.onPress();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onLongPressDetected", function () {
      _this.longPressDetected = true;

      _this.props.onLongPress();
    });

    _defineProperty(_assertThisInitialized(_this), "onMoveIn", function () {
      if (_this.STATE === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        // This call is not throttles with delays (like in RN's implementation).
        _this.moveToState(TOUCHABLE_STATE.BEGAN);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMoveOut", function () {
      // long press shouldn't be longer detected
      clearTimeout(_this.longPressTimeout);
      _this.longPressTimeout = null;

      if (_this.STATE === TOUCHABLE_STATE.BEGAN) {
        _this.handleMoveOutside();
      }
    });

    return _this;
  }

  _createClass(GenericTouchable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.reset();
    } // reset timeout to prevent memory leaks.

  }, {
    key: "reset",
    value: function reset() {
      this.longPressDetected = false;
      this.pointerInside = true;
      clearTimeout(this.pressInTimeout);
      clearTimeout(this.pressOutTimeout);
      clearTimeout(this.longPressTimeout);
      this.pressOutTimeout = null;
      this.longPressTimeout = null;
      this.pressInTimeout = null;
    } // All states' transitions are defined here.

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // to prevent memory leaks
      this.reset();
    }
  }, {
    key: "render",
    value: function render() {
      var coreProps = {
        accessible: this.props.accessible !== false,
        accessibilityLabel: this.props.accessibilityLabel,
        accessibilityHint: this.props.accessibilityHint,
        accessibilityComponentType: this.props.accessibilityComponentType,
        accessibilityRole: this.props.accessibilityRole,
        accessibilityStates: this.props.accessibilityStates,
        accessibilityTraits: this.props.accessibilityTraits,
        nativeID: this.props.nativeID,
        testID: this.props.testID,
        onLayout: this.props.onLayout,
        hitSlop: this.props.hitSlop
      };
      return React.createElement(BaseButton, _extends({
        onHandlerStateChange: this.props.disabled ? null : this.onHandlerStateChange,
        onGestureEvent: this.onGestureEvent,
        hitSlop: this.props.hitSlop
      }, this.props.extraButtonProps), React.createElement(Animated.View, _extends({}, coreProps, {
        style: this.props.style
      }), this.props.children));
    }
  }]);

  return GenericTouchable;
}(Component);

_defineProperty(GenericTouchable, "publicPropTypes", PublicPropTypes);

_defineProperty(GenericTouchable, "internalPropTypes", InternalPropTypes);

_defineProperty(GenericTouchable, "propTypes", _objectSpread({}, InternalPropTypes, {}, PublicPropTypes));

_defineProperty(GenericTouchable, "defaultProps", {
  delayLongPress: 600,
  extraButtonProps: {
    rippleColor: 'transparent'
  }
});

export { GenericTouchable as default };